///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.roles = abcsetup.roles || {};
abcsetup.roles.create = abcsetup.roles.create || {};

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.roles.create = {
    init: function() {
        abcsetup.setTitle('Create a Role');

        $("#app_role__role_class").change(function () {
            if ($(this).val()) {
                $("input[name='name']").val($(this).children(":selected").text());
            }
        });
    },
}